import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BsWhatsapp } from "react-icons/bs";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/header/header";
import { ScrollToTop } from "./utils/ScrollToTop";
import { Hero } from "./pages/hero/hero";
import { Services } from "./pages/services/services";
import { Success } from "./pages/success/success";
import { Footer } from "./components/footer/footer";
import { Testimonials } from "./pages/testimonials/testimonials";
import { Contactus } from "./pages/contactus/contactus";
import { ServicesPage } from "./pages/services/ServicesPage";
import { Contactuspage } from "./pages/contactus/contactuspage";
import { Projects } from "./pages/projects/projects";
import { Projectlanding } from "./pages/projects/projectlanding";
import { Faq } from "./pages/faq/faq";
import { About } from "./pages/about/about";

const HomePage = () => (
  <div className="jsr-bg">
    <Hero />
    <Services />
    <Success />
    <Projectlanding />
    <Testimonials />
    <Contactus />
    <Faq />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <div className="jsr-bg">
        <ScrollToTop />
        <Header />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<Contactuspage />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
        </Routes>

        <Footer />

        {/* WhatsApp FAB */}
        <a
          href="https://wa.me/919791509915"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-fab"
          aria-label="Chat on WhatsApp"
        >
          <BsWhatsapp />
        </a>
      </div>
    </BrowserRouter>
  );
}

export default App;
